module.exports = "/_next/static/images/coprehensive-cyber-assessments-6ac655143a2641bbd9233f8a1871d25c.webp";